import { useContext } from 'react';

import classes from './Layout.module.css';
import NavBar from './NavBar/NavBar';
import Footer from './Footer/Footer';
import NotificationContext from 'context/notification/notification-context';
import Notification from 'components/common/Notification/Notification';
import LangaugeSwitcher from 'components/common/LanguageSwitcher/LanguageSwitcher';

type Props = {
   children: JSX.Element | JSX.Element[];
};

const Layout = ({ children }: Props) => {
   const { notification } = useContext(NotificationContext);

   return (
      <div className={classes.layout}>
         <NavBar />
         <LangaugeSwitcher />
         {notification && (
            <Notification
               text={notification.text}
               isSuccess={notification.isSuccess}
               className={notification.className}
            />
         )}
         <main className={classes.main}>{children}</main>
         <Footer />
      </div>
   );
};

export default Layout;
